<template>
  <div>   
      <div class="row">
        <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                <li v-for="(item, indice) in lsttop10pro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <div class="row">
                        <div class="col-8">
                            <h5 class="txt-item-card-dash-top10-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                        </div>
                        <div class="col-4 text-right valconainer">
                            <template>
                                <h5 class="txt-item-card-dash-top10-val">{{ mtdformatavalordecimal(parseFloat(item.qtdentrada)) }} {{ mtdformatavalordecimal(parseFloat(item.qtdvenda)) }}({{ mtdformatavalordecimal(parseFloat(item.qtdvenda) / parseFloat(item.qtdentrada) * 100, '') }}%)</h5>
                            </template>
                        </div>
                    </div>                                                    
                </li>
            </ul>                                            
        </div>
      </div>
  </div>
</template>

<script>
import util from '../../utilitarios/util';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "BarChartCard",

  components:{
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
      usuariologado               : this.$store.state.usuario,
      lsttop10pro                 : [],

      isloading               : false,  
  
    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
     'qtdnotaspendentes',
  ],
  methods:{
       mtdformatavalordecimal(valor){
			  return util.formatarvalor(valor, '');
       },
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {
            vself.lsttop10pro             = response.data.top10giro;										
            vself.$emit('handlerLoader', false);
          }).catch(function (response) {
              vself.lsttop10pro             = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);
          });                
      },
  },
  mounted(){
    this.mtdresultadofaturamento();
  },
  computed:{
            
  },
}
</script>
